import PropTypes from 'prop-types';
import React from 'react';
import Validator from 'mixins/validator';
import Resetter from 'mixins/resetter';
import { Button, IconButton } from 'react-toolbox';
import { connect } from 'react-redux';
import { filter } from 'lodash';
import SimpleInput from 'components/SimpleInput';
import S from 'modal.scss';
import { getPhaseErrors } from '../../../../../../../reducers';
import Dropdown from 'react-toolbox/lib/dropdown';


const materialsResponsiblePartyOptions = phaseSource => [
  { value: phaseSource === 'IFI' ? 'IFI' : 'SPIG', label: phaseSource === 'IFI' ? 'IFI' : 'SPIG' },
  { value: 'Lowe\'s', label: 'Lowe\'s' },
];
class MaterialsNeeded extends Resetter(Validator(React.Component)) {
  constructor(props) {
    super(props);
    this.state = {
      materialsNeeded: this.props.materialsNeeded || [],
      materialsResponsibleParty: this.props.materialsResponsibleParty || '',
      addRow: false,
      itemNumber: '',
      itemDescription: '',
      itemQuantity: '',
      errors: {},
    };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.materialsResponsibleParty !== this.props.materialsResponsibleParty) {
      this.setState({ materialsResponsibleParty: nextProps.materialsResponsibleParty || '' });
    }
  }

  handleSubmit = (tab) => {
    if (tab === 4 && this.state.materialsNeeded.length > 0 &&
        !this.validate({ materialsResponsibleParty: true })) return;
    this.props.updateFormData({
      materialsNeeded: this.state.materialsNeeded,
      materialsResponsibleParty: this.state.materialsResponsibleParty,
      tab,
    });
  }

  handleFinish = () => this.handleSubmit(4);

  handlePrevious = () => this.handleSubmit(2);

  handleAddRow = (e) => {
    e.preventDefault();
    this.setState({
      addRow: !this.state.addRow,
      itemNumber: '',
      itemDescription: '',
      itemQuantity: '',
    });
  }

  handleCustomerInitials = e => this.setState({ customerInitials: e.target.value });

  handleItemNumber = e => this.setState({ itemNumber: e.target.value });

  handleItemDescription = e => this.setState({ itemDescription: e.target.value });

  handleItemQuantity = e => this.setState({ itemQuantity: e.target.value });

  handleMaterialsResponsibleParty = value => this.setState({ materialsResponsibleParty: value });

  handleSave = (e) => {
    e.preventDefault();
    const { materialsNeeded, itemNumber, itemDescription, itemQuantity,
            materialsResponsibleParty } = this.state;
    materialsNeeded.push({
      item_number: itemNumber,
      item_description: itemDescription,
      item_quantity: itemQuantity,
      materials_responsible_party: materialsResponsibleParty,
    });
    this.setState({
      itemNumber: '',
      itemDescription: '',
      itemQuantity: '',
      materialsNeeded,
      materialsResponsibleParty,
    });
  }

  handleDelete = itemNumber => (e) => {
    e.preventDefault();
    const materialsNeeded = this.state.materialsNeeded;
    const filteredMaterials = filter(materialsNeeded, material =>
      material.item_number !== itemNumber);
    this.setState({ materialsNeeded: filteredMaterials });
  }

  render = () => {
    const { materialsNeeded, addRow, itemNumber, itemDescription,
            itemQuantity, materialsResponsibleParty, errors } = this.state;
    const noTableText = addRow ?
      'Fill in data below, then click "Save"' :
      'Click "ADD" to start adding materials';
    return (<div>
      <h6 className={S.signatureTitle}>Materials Needed</h6>
      {materialsNeeded.length > 0 ? (<table className={S.table}>
        <thead>
          <tr className={S.headerRow}>
            <th className={S.cell}>Item Number</th>
            <th className={S.cell}>Item Description</th>
            <th className={S.cell}>Item Quantity</th>
            <th className={S.deleteCell}>Delete</th>
          </tr>
        </thead>
        <tbody>
          {materialsNeeded.map(material =>
            <tr className={S.contentRow} key={material.item_number}>
              <td className={S.cell}>{material.item_number}</td>
              <td className={S.cell}>{material.item_description}</td>
              <td className={S.cell}>{material.item_quantity}</td>
              <td className={S.deleteCell}>
                <IconButton
                  icon="delete"
                  onClick={this.handleDelete(material.item_number)}
                />
              </td>
            </tr>,
          )}
        </tbody>
      </table>) : (<div className={S.emptyTable}>
        <h4>{noTableText}</h4>
      </div>)}
      {materialsNeeded.length > 0 ? (<Dropdown
        label="Who is Responsible for the Materials? *"
        source={materialsResponsiblePartyOptions(this.props.phaseSource)}
        value={materialsResponsibleParty}
        onChange={this.handleMaterialsResponsibleParty}
        error={(errors.materialsResponsibleParty || [])[0]}
      />) : null}
      {addRow && <form onSubmit={this.handleSave}>
        <SimpleInput
          label="Item Number"
          text={itemNumber}
          onChange={this.handleItemNumber}
        />
        <SimpleInput
          label="Item Description"
          text={itemDescription}
          onChange={this.handleItemDescription}
        />
        <SimpleInput
          label="Item Quantity"
          text={itemQuantity}
          onChange={this.handleItemQuantity}
        />
        <input className={S.save} type="submit" value="Save" />
      </form>}
      <Button
        className={addRow ? S.cancel : S.add}
        label={addRow ? 'Done' : 'Add'}
        flat inverse ripple
        onClick={this.handleAddRow}
      />
      <Button
        label="Complete"
        flat inverse ripple
        className={S.submit}
        onClick={this.handleFinish}
      />
      <Button
        label="Previous"
        flat inverse ripple
        className={S.submit}
        onClick={this.handlePrevious}
      />
    </div>);
  }
}

MaterialsNeeded.propTypes = {
  materialsNeeded: PropTypes.array,
  materialsResponsibleParty: PropTypes.string,
  phaseSource: PropTypes.string,
  errors: PropTypes.shape({
    materialsNeeded: PropTypes.arrayOf(PropTypes.array),
  }),
};

export default connect(state => ({ errors: getPhaseErrors(state) }), {})(MaterialsNeeded);



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/phases/phaseShow/components/repairInspection/materialsNeeded.jsx